import {
  GetByAccountIdResponse,
  GetByGoalIdResponse,
  GetLineColorsResponse,
  UpdateProjectionResponse,
  WealthProjectionService,
} from '@simpleinvest/ms-wealth-projection-sdk';
// eslint-disable-next-line import/no-cycle
import {apiKey, getLogger} from '@client/services/sdk';
// eslint-disable-next-line import/no-cycle
import {
  requestInterceptorFulfilledHandler,
  requestInterceptorRejectedHandler,
  responseInterceptorFulfilledHandler,
  responseInterceptorRejectedHandler,
} from '@client/interceptors';
import {SourcePlatform} from '@simpleinvest/ms-core-sdk';

export default {
  getWealthProjectionServiceInstance(): WealthProjectionService {
    return new WealthProjectionService({
      apiKey,
      sourceInfo: {platform: SourcePlatform.ClientPlatform},
      interceptors: {
        requestInterceptor: requestInterceptorFulfilledHandler,
        requestRejectedInterceptor: requestInterceptorRejectedHandler,
        responseInterceptor: responseInterceptorFulfilledHandler,
        responseRejectedInterceptor: responseInterceptorRejectedHandler,
      },
      logger: getLogger(),
    });
  },

  async getWealthProjectionByAccountId(accountId: string): Promise<GetByAccountIdResponse> {
    const service: WealthProjectionService = await this.getWealthProjectionServiceInstance();

    return service.getByAccountId({accountId});
  },

  async getWealthProjectionByGoalId(goalId: string): Promise<GetByGoalIdResponse> {
    const service: WealthProjectionService = await this.getWealthProjectionServiceInstance();

    return service.getByGoalId({goalId});
  },

  async getProjectionLineColors(clUserId: string): Promise<GetLineColorsResponse> {
    const service: WealthProjectionService = await this.getWealthProjectionServiceInstance();

    return service.getLineColors({clUserId});
  },

  async updateWealthProjectionByAccountId({
    projectionId,
    accountId,
    oneTimeContribution,
    targetAmount,
    monthlySavings,
    monthlyWithdrawal,
    yearsToDisplay,
    inflation,
  }: {
    projectionId: string;
    accountId: string;
    oneTimeContribution: number;
    targetAmount: number;
    monthlySavings: number;
    monthlyWithdrawal: number;
    yearsToDisplay: number;
    inflation: number;
  }): Promise<UpdateProjectionResponse> {
    const service: WealthProjectionService = await this.getWealthProjectionServiceInstance();

    return service.updateByAccountId({
      projectionId,
      accountId,
      oneTimeContribution,
      targetAmount,
      monthlySavings,
      monthlyWithdrawal,
      yearsToDisplay,
      inflation,
    });
  },

  async updateWealthProjectionByGoalId({
    projectionId,
    goalId,
    oneTimeContribution,
    targetAmount,
    monthlySavings,
    monthlyWithdrawal,
    yearsToDisplay,
    inflation,
  }: {
    projectionId: string;
    goalId: string;
    oneTimeContribution: number;
    targetAmount: number;
    monthlySavings: number;
    monthlyWithdrawal: number;
    yearsToDisplay: number;
    inflation: number;
  }): Promise<UpdateProjectionResponse> {
    const service: WealthProjectionService = await this.getWealthProjectionServiceInstance();

    return service.updateByGoalId({
      projectionId,
      goalId,
      oneTimeContribution,
      targetAmount,
      monthlySavings,
      monthlyWithdrawal,
      yearsToDisplay,
      inflation,
    });
  },
};
